/**
 * Animate history
 */
export const historyPage = () => {
    (function ($) {
      $(document).ready(function () {
        // observerScroll('.block-history__wrap:not(.animate)')
        let selectorDom = document.querySelectorAll('.block-history__wrap .block-history__content-wrap');
        for (let i = 0; i < selectorDom.length; i++) {
          observerScroll(selectorDom[i])
        }
      })
    })(jQuery)
}

const observerScroll = (domElement) => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.intersectionRatio >= 0.6) {
        if( !domElement.classList.contains('animate')) {
          domElement.classList.add('animate')
        }
      }
    },
    {
      root: null,
      rootMargin: '0px',
      threshold: 0.6,
    }
  )

  if (domElement) {
    observer.observe(domElement)
  }
}